import { render } from "./News.vue?vue&type=template&id=f638a3c2"
const script = {}
script.render = render

export default script